export const REVIEW_STATUS_IDS = {
  pending: 125,
  approved: 150,
  partiallyApproved: 170,
  rejected: 190,
};

const REVIEW_STATUS_BY_SHORTCUT = {
  0: REVIEW_STATUS_IDS.pending,
  1: REVIEW_STATUS_IDS.approved,
  2: REVIEW_STATUS_IDS.partiallyApproved,
  3: REVIEW_STATUS_IDS.rejected,
};

const PAYMENT_REVIEW_STATUS_BY_SHORTCUT = {
  0: REVIEW_STATUS_IDS.pending,
  1: REVIEW_STATUS_IDS.approved,
  3: REVIEW_STATUS_IDS.rejected,
};

export const getReviewStatusByShortcut = (key) =>
  REVIEW_STATUS_BY_SHORTCUT[key] ?? null;

export const getPaymentReviewStatusByShortcut = (key) =>
  PAYMENT_REVIEW_STATUS_BY_SHORTCUT[key] ?? null;

export const isApprovedAmountStatus = (statusId) => {
  const normalizedStatusId = Number(statusId);

  return (
    normalizedStatusId === REVIEW_STATUS_IDS.approved ||
    normalizedStatusId === REVIEW_STATUS_IDS.partiallyApproved
  );
};

export const isPartiallyApprovedStatus = (statusId) =>
  Number(statusId) === REVIEW_STATUS_IDS.partiallyApproved;

export const getApprovedAmountFocusTarget = (rowId, statusId) =>
  isPartiallyApprovedStatus(statusId) ? rowId : null;

export const getApprovedAmountForStatusTransition = ({
  nextStatusId,
  totalAmount,
}) => {
  if (!isApprovedAmountStatus(nextStatusId)) return 0;

  if (Number(nextStatusId) !== REVIEW_STATUS_IDS.approved) return undefined;

  if (totalAmount === undefined || totalAmount === null || totalAmount === "") {
    return undefined;
  }

  const normalizedTotalAmount = Number(totalAmount);
  return Number.isFinite(normalizedTotalAmount)
    ? normalizedTotalAmount
    : undefined;
};

export const evaluateApprovedAmountFormula = (input) => {
  const rawValue = input?.toString?.().trim?.() ?? "";
  if (!rawValue.startsWith("=")) return undefined;

  const expression = rawValue.slice(1).replace(/\s/g, "").replace(/,/g, ".");
  if (
    !expression ||
    expression.length > 200 ||
    !/^[0-9+\-*/().]+$/.test(expression)
  ) {
    return null;
  }

  let position = 0;

  const parseNumber = () => {
    const start = position;
    let decimalPoints = 0;

    while (position < expression.length) {
      const character = expression[position];
      if (character === ".") {
        decimalPoints += 1;
        if (decimalPoints > 1) return Number.NaN;
      } else if (!/\d/.test(character)) {
        break;
      }
      position += 1;
    }

    const token = expression.slice(start, position);
    if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(token)) return Number.NaN;

    return Number(token);
  };

  const parseFactor = () => {
    const character = expression[position];

    if (character === "+" || character === "-") {
      position += 1;
      const value = parseFactor();
      return character === "-" ? -value : value;
    }

    if (character === "(") {
      position += 1;
      const value = parseExpression();
      if (expression[position] !== ")") return Number.NaN;
      position += 1;
      return value;
    }

    return parseNumber();
  };

  const parseTerm = () => {
    let value = parseFactor();

    while (expression[position] === "*" || expression[position] === "/") {
      const operator = expression[position];
      position += 1;
      const operand = parseFactor();
      value = operator === "*" ? value * operand : value / operand;
    }

    return value;
  };

  function parseExpression() {
    let value = parseTerm();

    while (expression[position] === "+" || expression[position] === "-") {
      const operator = expression[position];
      position += 1;
      const operand = parseTerm();
      value = operator === "+" ? value + operand : value - operand;
    }

    return value;
  }

  const result = parseExpression();
  return position === expression.length && Number.isFinite(result)
    ? result
    : null;
};

export const validateApprovedAmount = (amount, totalAmount) =>
  Number.isFinite(amount) &&
  Number.isFinite(totalAmount) &&
  amount > 0 &&
  amount <= totalAmount;

export const getApprovedAmountValidationMessage = (amount, totalAmount) => {
  if (!Number.isFinite(amount)) {
    return "Το εγκεκριμένο ποσό είναι υποχρεωτικό.";
  }

  return validateApprovedAmount(amount, totalAmount)
    ? ""
    : "Το εγκεκριμένο ποσό πρέπει να είναι μεγαλύτερο από 0 και μικρότερο ή ίσο με το σύνολο.";
};

export const shouldValidateApprovedAmountOnBlur = (hasEdited) =>
  hasEdited === true;

export const shouldCommitApprovedAmount = (validationMessage) =>
  !validationMessage;

export const getApprovedAmountCellValue = (formattedValue, validationMessage) =>
  validationMessage ? "" : formattedValue;
